import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Form"] */ "/home/will/Documents/Business/wise/repos/wise/site/app/(auth)/register/components/Form.tsx");
